import { styled } from "styled-components";

// 날짜
export const PostDate = styled.time`
  font-size: 12px;
`;
